import { render, staticRenderFns } from "./poissaolon-syyt.vue?vue&type=template&id=5d85bf50&scoped=true&"
import script from "./poissaolon-syyt.vue?vue&type=script&lang=ts&"
export * from "./poissaolon-syyt.vue?vue&type=script&lang=ts&"
import style0 from "./poissaolon-syyt.vue?vue&type=style&index=0&id=5d85bf50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85bf50",
  null
  
)

export default component.exports